import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


export const AutoCompleteData = createAsyncThunk(
    'AutoComplete',
    async (data, thunkAPI) => {
        try {
            let res = await fetch('/api/AutoComplete/GetMasterData', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return res.json()
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const initialState = {
   AutoCompleteList : null,
    error: null,
    loading: false,
};


const AutoCompleteSlice = createSlice({
    name: 'AutoCompleteSlice',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(AutoCompleteData.fulfilled, (state, action) => {
            state.AutoCompleteList = action.payload
            state.loading = false;
        })
            .addCase(AutoCompleteData.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(AutoCompleteData.rejected, (state, action) => {
                state.error = action.payload
                state.loading = false;
            })
        //.addCase(getUserCompanyList.fulfilled, (state, action) => {
        //    state.getUserCompanyList = action.payload;
        //    state.loading = false;
        //}).addCase(getUserCompanyList.pending, (state, action) => {
        //    state.loading = true;
        //}).addCase(getUserCompanyList.rejected, (state, action) => {
        //    state.getUserCompanyList = action.payload;
        //    state.loading = false;
        //})
    }

});

export const Action = AutoCompleteSlice.actions

export default AutoCompleteSlice.reducer